(() => {
  'use strict';
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const strings = JSON.parse($('#CatStrings')?.textContent || '{}');
  const root = (document.body.dataset.root || '/').replace(/\/?$/, '/');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const status = $('#ShopStatus');
  let returnFocus;
  let quickRequest;
  let searchRequest;
  let cartQueue = Promise.resolve();
  let searchTimer;
  const dialogAnimations = new WeakMap();
  const enqueueCart = work => (cartQueue = cartQueue.catch(() => {}).then(work));
  const disabledStates = new WeakMap();
  function setCartBusy(busy) {
    $$('#CartDialog, .cart-page').forEach(scope => {
      scope.toggleAttribute('aria-busy', busy);
      if (busy) scope.setAttribute('aria-busy', 'true');
      $$('[data-quantity-input], [data-quantity-change], [name="checkout"]', scope).forEach(el => {
        if (busy) { if (!disabledStates.has(el)) disabledStates.set(el, el.disabled); el.disabled = true; }
        else if (disabledStates.has(el)) { el.disabled = disabledStates.get(el); disabledStates.delete(el); }
      });
    });
  }
  function dialogTransform(dialog) {
    return dialog.id === 'MenuDialog' ? 'translateY(-12px) scale(.985)' : dialog.classList.contains('panel') ? 'translateX(100%)' : dialog.classList.contains('quick-dialog') && innerWidth < 750 ? 'translateY(32px)' : 'translateY(14px) scale(.985)';
  }
  const say = (message) => { if (status) status.textContent = message; };
  function openDialog(id, trigger) {
    const dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    $$('details.mega-trigger[open]').forEach(el => el.open = false);
    const origin = trigger || document.activeElement;
    const keepReels = ['QuickDialog','CartDialog'].includes(id) && document.querySelector('.reels-dialog[open]');
    $$('dialog[open]').forEach(el => { if (!(keepReels && el.classList.contains('reels-dialog'))) el.close(); });
    dialogAnimations.get(dialog)?.cancel();
    const albumOrigin = document.getElementById(origin?.closest('dialog')?.dataset.returnFocus || '');
    if (albumOrigin) returnFocus = albumOrigin;
    else if (origin?.closest('.reels-dialog') || !origin?.closest('dialog')) returnFocus = origin;
    dialog.showModal();
    if (!reduced.matches && dialog.animate) {
      const motion = dialog.animate([{ transform: dialogTransform(dialog), opacity: .6 }, { transform: 'none', opacity: 1 }], { duration: 340, easing: 'cubic-bezier(.32,.72,0,1)' });
      dialogAnimations.set(dialog, motion);
    }
    if (id === 'SearchDialog') $('#PredictiveQuery')?.focus();
    return true;
  }
  function closeDialog(dialog) {
    if (!dialog) return;
    dialogAnimations.get(dialog)?.cancel();
    const finish = () => {
      dialog.close();
      if (returnFocus?.isConnected && returnFocus.getClientRects().length) returnFocus.focus({ preventScroll: true });
    };
    if (reduced.matches || !dialog.animate) { finish(); return; }
    const motion = dialog.animate([{ transform: getComputedStyle(dialog).transform, opacity: 1 }, { transform: dialogTransform(dialog), opacity: 0 }], { duration: 180, easing: 'cubic-bezier(.4,0,1,1)' });
    dialogAnimations.set(dialog, motion); motion.finished.then(finish).catch(() => {});
  }
  function errorIn(form, message) {
    const area = $('[data-form-error]', form);
    if (area) { area.textContent = message; area.hidden = false; }
    say(message);
  }
  function requireChoice(form) {
    errorIn(form, form.dataset.choiceError || strings.select);
    form.classList.add('is-choice-required');
    const group = $('.variant-pills', form);
    const error = $('[data-form-error]', form);
    if (group) { group.setAttribute('aria-invalid', 'true'); group.setAttribute('aria-describedby', error.id); }
    const select = $('select[name="id"]', form);
    select?.setAttribute('aria-invalid', 'true');
    const first = $('input[name="variant-choice"]:not(:disabled)', form);
    first?.focus({preventScroll:true});
    (group || select)?.scrollIntoView({behavior:reduced.matches?'instant':'smooth',block:'center'});
  }
  function setupForms(scope = document) {
    $$('[data-product-form]', scope).forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const select = $('select[name="id"]', form);
      if (!select) return;
      select.required = false;
      select.tabIndex = -1;
      select.setAttribute('aria-hidden', 'true');
      const update = () => {
        const option = select.selectedOptions[0];
        const id = select.value;
        if (id && option) {
          $('[data-product-price]', form).textContent = option.dataset.price || '';
          $('[data-product-compare]', form).textContent = option.dataset.compare || '';
          const stock = $('[data-stock-status]', form);
          if (stock) { stock.dataset.state = option.dataset.stockState.trim(); $('[data-stock-label]', stock).textContent = option.dataset.stockLabel.trim(); }
          $('[data-add-label]', form).textContent = option.disabled ? strings.sold : strings.add;
          $('[name="add"]', form).disabled = option.disabled;
          const input = $(`input[name="variant-choice"][value="${CSS.escape(id)}"]`, form);
          if (input) input.checked = true;
          $('[data-form-error]', form).hidden = true;
          form.classList.remove('is-choice-required');
          select.removeAttribute('aria-invalid');
          const group = $('.variant-pills', form);
          group?.removeAttribute('aria-invalid'); group?.removeAttribute('aria-describedby');
          if (form.getAttribute('id')?.startsWith('ProductForm-')) {
            const url = new URL(location.href); url.searchParams.set('variant', id);
            history.replaceState({}, '', url);
            $('[data-sticky-price]') && ($('[data-sticky-price]').textContent = option.dataset.price);
            const stickyAdd = $('[data-sticky-add]');
            if (stickyAdd) { stickyAdd.firstChild.textContent = (option.disabled ? strings.sold : strings.add) + ' '; stickyAdd.disabled = option.disabled; }
            if (option.dataset.image) {
              const media = document.getElementById('Media-' + option.dataset.image);
              const gallery = $('#ProductGallery');
              if (media && gallery && gallery.scrollWidth > gallery.clientWidth) gallery.scrollTo({left: media.getBoundingClientRect().left - gallery.getBoundingClientRect().left + gallery.scrollLeft, behavior: reduced.matches ? 'instant' : 'smooth'});
            }
          }
        }
      };
      form.addEventListener('change', event => {
        if (event.target.name === 'variant-choice') select.value = event.target.value;
        update();
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (form.dataset.submitting) return;
        if (!select.value || select.selectedOptions[0]?.disabled) {
          requireChoice(form);
          return;
        }
        form.dataset.submitting = 'true';
        const button = $('[name="add"]', form);
        const label = $('[data-add-label]', form);
        button.disabled = true;
        label.textContent = strings.adding;
        $('[data-form-error]', form).hidden = true;
        let didAdd = false;
        try {
          await enqueueCart(async () => {
          const data = new FormData(form);
          data.delete('variant-choice');
          data.set('sections', 'cat-cart-drawer');
          data.set('sections_url', location.pathname);
          const response = await fetch(root + 'cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || strings.error);
          didAdd = true;
          if (result.sections?.['cat-cart-drawer']) replaceCart(result.sections['cat-cart-drawer']);
          else await refreshCart();
          });
          say(strings.added);
          openDialog('CartDialog', button);
        } catch (error) {
          errorIn(form, didAdd ? strings.cart_recover : error instanceof TypeError ? strings.error : error.message);
          if (didAdd) {
            const link = document.createElement('a'); link.href = root + 'cart'; link.className = 'cart-recovery'; link.textContent = strings.cart_recover;
            $('[data-form-error]', form).append(link);
          }
        } finally {
          delete form.dataset.submitting;
          button.disabled = !select.value || select.selectedOptions[0]?.disabled;
          label.textContent = select.selectedOptions[0]?.disabled ? strings.sold : strings.add;
        }
      });
      if (select.value) update();
    });
  }
  function replaceCart(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const content = $('[data-cart-content]', parsed);
    if (!content) throw new Error(strings.error);
    const count = content.dataset.itemCount;
    const current = $('#CartDialog [data-cart-content]');
    if (current) current.replaceWith(content);
    $$('[data-cart-count]').forEach(el => { const changed = el.textContent !== count; el.textContent = count; if (changed && !reduced.matches) { el.classList.add('is-updated'); setTimeout(() => el.classList.remove('is-updated'), 650); } });
    const cartPage = $('.cart-page [data-cart-content]');
    if (cartPage) {
      const clone = content.cloneNode(true);
      $$('[id]', clone).forEach(el => { el.id = el.id.replace('drawer', 'page'); });
      $$('label[for]', clone).forEach(el => { el.htmlFor = el.htmlFor.replace('drawer', 'page'); });
      cartPage.replaceWith(clone);
    }
  }
  async function refreshCart() {
    const response = await fetch(root + 'cart?section_id=cat-cart-drawer', { headers: { Accept: 'text/html' } });
    if (!response.ok) throw new Error(strings.error);
    replaceCart(await response.text());
  }
  function updateLine(key, quantity, focusSpec) {
    setCartBusy(true);
    enqueueCart(async () => {
      const dialog = $('#CartDialog');

      const formError = $('#CartDialog [data-cart-error]') || $('.cart-page [data-cart-error]');
      if (formError) formError.hidden = true;
      try {
        const response = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: ['cat-cart-drawer'], sections_url: location.pathname }) });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || strings.error);
        if (data.sections?.['cat-cart-drawer']) replaceCart(data.sections['cat-cart-drawer']);
        else await refreshCart();
        const currentScope = dialog?.open ? dialog : $('.cart-page');
        const line = currentScope && $(`[data-line-key="${CSS.escape(key)}"]`, currentScope);
        const target = line && (focusSpec === 'input' ? $('[data-quantity-input]', line) : $(`[data-quantity-change="${focusSpec}"]`, line));
        if (target) target.focus({ preventScroll: true });
        else if (currentScope) $('.checkout-button', currentScope)?.focus({ preventScroll: true });
        say(strings.bag_updated || strings.added);
      } catch (error) {
        try { await refreshCart(); } catch {}
        const area = $('#CartDialog[open] [data-cart-error]') || $('.cart-page [data-cart-error]');
        if (area) { area.textContent = error instanceof TypeError ? strings.error : error.message; area.hidden = false; }
        say(error.message || strings.error);
      } finally { setCartBusy(false); }
    });
  }
  document.addEventListener('click', async event => {
    const target = event.target.closest('a,button,summary');
    if (!target) return;
    if (target.hasAttribute('data-close')) { closeDialog(target.closest('dialog')); return; }
    if (target.dataset.open && !(event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)) {
      if (openDialog(target.dataset.open, target)) {
        event.preventDefault();
        if (target.dataset.open === 'CartDialog') enqueueCart(refreshCart).catch(() => say(strings.error));
      }
      return;
    }
    if (target.dataset.quick && !(event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)) {
      event.preventDefault();
      if (!openDialog('QuickDialog', target)) { location.href = target.href; return; }
      quickRequest?.abort();
      quickRequest = new AbortController();
      const area = $('#QuickContent');
      area.replaceChildren();
      const loading = document.createElement('p'); loading.className = 'quick-loading'; loading.textContent = strings.loading; area.append(loading);
      try {
        const url = new URL(target.dataset.quick, location.origin); url.searchParams.set('section_id', 'cat-quick-view');
        const response = await fetch(url, { signal: quickRequest.signal });
        if (!response.ok) throw new Error(strings.error);
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const view = $('.quick-view', parsed);
        if (!view) throw new Error(strings.error);
        area.replaceChildren(view); setupForms(area);
      } catch (error) {
        if (error.name === 'AbortError') return;
        area.replaceChildren();
        const link = document.createElement('a'); link.className = 'button'; link.href = target.href; link.textContent = strings.error + ' '; link.insertAdjacentHTML('beforeend', '<svg class="glyph" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M2.5 8h11M9.5 4l4 4-4 4"/></svg>'); area.append(link);
      }
      return;
    }
    if (target.dataset.zoom) {
      event.preventDefault();
      const img = $('#ZoomImage'); img.src = target.dataset.zoom; img.alt = $('img', target)?.alt || '';
      openDialog('ZoomDialog', target); return;
    }
    if (target.hasAttribute('data-size-link')) {
      if (document.getElementById('ProductSizeDialog')) { event.preventDefault(); openDialog('ProductSizeDialog',target); return; }
      const destination = new URL(target.href, location.origin);
      const details = destination.pathname === location.pathname && destination.hash ? $(destination.hash) : null;
      if (details) { event.preventDefault(); details.open = true; details.scrollIntoView({ behavior: reduced.matches ? 'instant' : 'smooth', block: 'center' }); $('summary', details)?.focus({ preventScroll: true }); }
      return;
    }
    if (target.hasAttribute('data-sticky-add')) {
      const form = document.getElementById($('[data-sticky-buy]').dataset.formId);
      if ($('select[name="id"]', form)?.value) form.requestSubmit();
      else requireChoice(form);
      return;
    }
    if (target.hasAttribute('data-quantity-change') || target.hasAttribute('data-remove-line')) {
      event.preventDefault();
      if (target.closest('[aria-busy="true"]')) return;
      const line = target.closest('[data-line-key]');
      if (!line) return;
      const input = $('[data-quantity-input]', line);
      const quantity = target.hasAttribute('data-remove-line') ? 0 : Math.max(0, Number(input.value) + Number(target.dataset.quantityChange));
      input.value = String(quantity);
      updateLine(line.dataset.lineKey, quantity, target.dataset.quantityChange);
    }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-sort]')) event.target.form.requestSubmit();
    if (event.target.matches('[data-quantity-input]')) {
      const input = event.target;
      const value = Number(input.value);
      if (!Number.isInteger(value) || value < 0) { input.reportValidity(); return; }
      updateLine(input.closest('[data-line-key]').dataset.lineKey, value, 'input');
    }
  });
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-predictive]')) return;
    clearTimeout(searchTimer); searchRequest?.abort();
    const query = event.target.value.trim();
    const area = $('#PredictiveResults');
    if (query.length < 2) { area.replaceChildren(); area.removeAttribute('aria-busy'); return; }
    searchTimer = setTimeout(async () => {
      searchRequest = new AbortController();
      area.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(root + 'search/suggest', location.origin);
        url.searchParams.set('q', query); url.searchParams.set('resources[type]', 'product'); url.searchParams.set('resources[limit]', '6'); url.searchParams.set('section_id', 'cat-predictive-search');
        const response = await fetch(url, { signal: searchRequest.signal });
        if (!response.ok) throw new Error(strings.error);
        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const results = $('.predictive-list', parsed);
        if (results) area.replaceChildren(results);
        else area.textContent = strings.search_empty;
      } catch (error) { if (error.name !== 'AbortError') area.textContent = strings.error; }
      finally { area.removeAttribute('aria-busy'); }
    }, 180);
  });
  const megaAnimations = new WeakMap();
  function closeDisclosure(details, restoreFocus = false) {
    if (!details.classList.contains('mega-trigger') || reduced.matches) { details.open = false; if (restoreFocus) $('summary',details)?.focus({preventScroll:true}); return; }
    if (details.dataset.closing) return;
    const panel = $('.mega-menu', details);
    if (!panel?.animate) { details.open = false; return; }
    megaAnimations.get(details)?.cancel();
    details.dataset.closing = 'true';
    const motion = panel.animate([{opacity:1,transform:'none'},{opacity:0,transform:'translateY(-8px)'}],{duration:180,easing:'cubic-bezier(.4,0,1,1)'});
    megaAnimations.set(details,motion);
    motion.finished.then(()=>{
      details.open = false; delete details.dataset.closing;
      if (restoreFocus) $('summary',details)?.focus({preventScroll:true});
    }).catch(()=>{});
  }
  $$('.mega-trigger>summary').forEach(summary=>summary.addEventListener('click',event=>{
    const details = summary.parentElement;
    if (details.dataset.closing) {
      event.preventDefault(); megaAnimations.get(details)?.cancel(); delete details.dataset.closing;
    } else if (details.open) { event.preventDefault(); closeDisclosure(details); }
  }));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') $$('details[open].mega-trigger,details[open].filter-disclosure').forEach(el => closeDisclosure(el,el.contains(document.activeElement)));
  });
  document.addEventListener('click', event => {
    $$('details[open].mega-trigger,details[open].filter-disclosure').forEach(el => { if (!el.contains(event.target)) closeDisclosure(el); });
  });
  $$('dialog:not(.album-dialog):not(.reels-dialog)').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeDialog(dialog);
    });
    dialog.addEventListener('cancel', event => { event.preventDefault(); closeDialog(dialog); });
  });
  // One navigation, two materials. Retarget the spring from its live position/velocity.
  const header = $('.site-header');
  if (header) {
    const announcement = $('.announcement',header);
    const reduceHeader = matchMedia('(prefers-reduced-motion: reduce)');
    const targetForScroll = () => {
      if (reduceHeader.matches) return window.scrollY > 72 ? 1 : 0;
      const distance = Math.min(1,Math.max(0,(window.scrollY - 12) / 156));
      return distance * distance * (3 - 2 * distance);
    };
    let position = targetForScroll(), velocity = 0;
    let frame = 0, previousTime = 0;
    const paint = () => {
      header.style.setProperty('--header-progress',position.toFixed(4));
      if (announcement) announcement.inert = position > .42;
    };
    const measure = () => {
      const inset = parseFloat(getComputedStyle(header).getPropertyValue('--header-float-inset')) || 0;
      header.style.setProperty('--header-scale-x',(1 - 2 * inset / Math.max(1,header.clientWidth)).toFixed(6));
    };
    const tick = time => {
      const target = targetForScroll();
      const delta = Math.min(.04,(previousTime ? time - previousTime : 16.7) / 1000);
      previousTime = time;
      if (reduceHeader.matches) { position=target; velocity=0; }
      else {
        // Exact critically damped spring: stable at different refresh rates, no bounce.
        const omega=26, offset=position-target, impulse=velocity+omega*offset;
        const decay=Math.exp(-omega*delta);
        position=target+(offset+impulse*delta)*decay;
        velocity=(velocity-omega*impulse*delta)*decay;
        if (position<0 || position>1) { position=Math.min(1,Math.max(0,position)); velocity=0; }
        if (Math.abs(target-position)<.0002 && Math.abs(velocity)<.003) { position=target; velocity=0; }
      }
      paint();
      if (position!==target || velocity!==0) frame=requestAnimationFrame(tick);
      else { frame=0; previousTime=0; }
    };
    const schedule = () => { if(!frame) frame=requestAnimationFrame(tick); };
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',measure,{passive:true});
    window.addEventListener('pageshow',()=>{ measure(); schedule(); });
    reduceHeader.addEventListener('change',schedule);
    measure(); paint();
  }
  window.SobremesaDialogs = Object.freeze({ open: openDialog, close: closeDialog });
  setupForms();
  const sticky = $('[data-sticky-buy]');
  if (sticky && 'IntersectionObserver' in window) {
    const form = document.getElementById(sticky.dataset.formId);
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      sticky.classList.toggle('is-visible', !entry.isIntersecting && (innerWidth < 750 || entry.boundingClientRect.top < 0));
    }, { threshold: 0 });
    if (form) observer.observe(form);
  }
  async function loadRecommendations(el) {
    if (el.dataset.loaded || !el.dataset.productId) return;
    el.dataset.loaded = 'true';
    try {
      const url = new URL(root + 'recommendations/products', location.origin);
      url.searchParams.set('product_id', el.dataset.productId); url.searchParams.set('section_id', el.dataset.sectionId); url.searchParams.set('limit', '10'); url.searchParams.set('intent', 'related');
      const response = await fetch(url); if (!response.ok) return;
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const updated = $('[data-recommendations]', parsed);
      // Keep the editorial fallback if Shopify has fewer than two relevant recommendations.
      if (updated && $$('.product-card', updated).length >= 2) el.replaceWith(updated);
    } catch { /* The server-rendered selection is already usable. */ }
  }
  function setupRecommendations(scope = document) {
    $$('[data-recommendations]', scope).forEach(el => {
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => { if (entries.some(e => e.isIntersecting)) { observer.disconnect(); loadRecommendations(el); } }, { rootMargin: '400px' }); observer.observe(el);
      } else loadRecommendations(el);
    });
  }
  setupRecommendations();
  document.addEventListener('shopify:section:load', event => { setupForms(event.target); setupRecommendations(event.target); });
  window.addEventListener('pageshow', event => { if (event.persisted) enqueueCart(refreshCart).catch(() => {}); });
})();
